Namespace 'Monitoring.Models.SocialContents.GoogleMyBusiness'

class Monitoring.Models.SocialContents.GoogleMyBusiness.GoogleMyBusinessAddress
  constructor: (builder) ->
    @regionCode = builder.getRegionCode()
    @administrativeArea = builder.getAdministrativeArea()
    @locality = builder.getLocality()
    @subLocality = builder.getSubLocality()
    @addressLines = builder.getAddressLines()

  getRegionCode: ->
    @regionCode

  getAdministrativeArea: ->
    @administrativeArea

  getLocality: ->
    @locality

  getSubLocality: ->
    @subLocality

  getAddressLines: ->
    @addressLines

  joinAddressLines: ->
    @addressLines.join(', ') if @addressLines

  toString: ->
    _.compact([@regionCode, @administrativeArea, @locality, @subLocality, @joinAddressLines()]).join(' | ')
